import { render, staticRenderFns } from "./Medicalresourcesinfo.vue?vue&type=template&id=ef6bc2c2&"
import script from "./Medicalresourcesinfo.vue?vue&type=script&lang=js&"
export * from "./Medicalresourcesinfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports